import { useCallback } from 'react';

import { useAxios } from '../axios';
import { GetTerminalParams, Terminal } from './terminal.types';

export const useGetTerminals = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: Terminal[]; count: number };
  }>({
    method: 'GET',
  });

  const getTerminals = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
    }: GetTerminalParams) =>
      axiosFetch({
        url: '/counterparty/terminal',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getTerminals,
  };
};
